// extracted by mini-css-extract-plugin
module.exports = {"detailsBody":"_e5fcdf5","bonusIcon":"_c73c349","detailsMessage":"_e9552b8","termsAndConditions":"_9ba0b77","termsAndConditionsIcon":"_b0a37dc"};